var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EventEmitter } from '@angular/core';
import { AbstractInputFileDirective } from './abstract-input-file.directive';
var InputFileDirective = /** @class */ (function (_super) {
    __extends(InputFileDirective, _super);
    function InputFileDirective() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.upload = new EventEmitter();
        return _this;
    }
    InputFileDirective.prototype.ngOnDestroy = function () {
        document.body.removeChild(this._input);
    };
    InputFileDirective.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this._input = document.createElement('input');
        this._input.type = 'file';
        this._input.style.height = '0px';
        this._input.style.opacity = '0';
        this._input.style.position = 'fixed';
        this._input.style.visibility = 'hidden';
        this._input.style.width = '0px';
        this._input.setAttribute('accept', this._accept.toString());
        if (this._multiple) {
            this._input.setAttribute('multiple', 'multiple');
        }
        this._input.addEventListener('change', function () {
            var files = _this._onFileSelect(_this._input.files);
            _this.upload.emit(files);
            _this._input.value = null;
        });
        document.body.appendChild(this._input);
    };
    InputFileDirective.prototype._onClick = function () {
        var event = document.createEvent('MouseEvents');
        event.initEvent('click', true, true);
        this._input.dispatchEvent(event);
    };
    return InputFileDirective;
}(AbstractInputFileDirective));
export { InputFileDirective };
